import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫屋',
  url: 'http://xxxlc.com/',
  description: '韩漫屋汇集韩漫大全，提供漫画韩漫网址和下拉式韩国漫画在线阅读服务，方便您快速找到并阅读所需作品。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://xxxlc.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫屋',
  url: 'http://xxxlc.com/',
  description: '免费韩漫在线阅读平台，提供高清无删减韩国漫画',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-1234',
    contactType: 'customer service',
    email: 'hello@xxxlc.com',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <TestimonialSection />
        <FaqSection />
        <CtaSection />
      </main>

      <Footer />
    </div>
  );
}